import { Option, None } from "@siteimprove/alfa-option";
import { Sequence } from "@siteimprove/alfa-sequence";
import { Attributes } from "./attribute/data.js";
import { Role } from "./role.js";
/**
 * @public
 */
export class Attribute {
    static of(name, value) {
        return new Attribute(name, value);
    }
    _name;
    _value;
    constructor(name, value) {
        this._name = name;
        this._value = value;
    }
    get name() {
        return this._name;
    }
    get value() {
        return this._value;
    }
    get kind() {
        return Attributes[this._name].kind;
    }
    get type() {
        return Attributes[this._name].type;
    }
    get default() {
        const value = Attributes[this._name].default;
        if (value === null) {
            return None;
        }
        return Option.of(value);
    }
    get options() {
        const options = Attributes[this._name].options;
        if (options === null) {
            return Sequence.empty();
        }
        return Sequence.from(options);
    }
    /**
     * {@link https://www.w3.org/TR/wai-aria/#global_states}
     */
    isGlobal() {
        return Role.of("roletype").isAttributeSupported(this._name);
    }
    equals(value) {
        return (value instanceof Attribute &&
            value._name === this._name &&
            value._value === this._value);
    }
    toJSON() {
        return {
            name: this._name,
            value: this._value,
        };
    }
}
/**
 * @public
 */
(function (Attribute) {
    function isName(value) {
        return value in Attributes;
    }
    Attribute.isName = isName;
})(Attribute || (Attribute = {}));
//# sourceMappingURL=attribute.js.map